import { useSnapshot } from 'hooks/use-safe-snapshot';
import { state } from 'state/current-project-design';

const useCurrentDesign = () => {
    const { projectDesign } = useSnapshot(state);

    return projectDesign;
};

export { useCurrentDesign };
